import React from 'react';

import styled from '@emotion/styled';

import { COLORS, FontWeight } from '@clutter/clean';

import { client } from '@admin/libraries/apollo';
import { useAccountBanQuery } from '@admin/schema';

const BanAlert = styled.div`
  color ${COLORS.toucan};
  font-weight: ${FontWeight.Bold};
`;

export const BanInfo: React.FC<{ accountID: string }> = ({ accountID }) => {
  const { data } = useAccountBanQuery({ client, variables: { accountID } });

  if (!data) {
    return null;
  }

  return (
    <>
      {data.account.bannedFromBooking && (
        <div>
          <BanAlert>This account has been disabled and cannot book further appointments</BanAlert>
          <strong>Disable Reason: </strong>
          <span>{data.account.banReason}</span>
        </div>
      )}
    </>
  );
};
